import { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import arrow_right from "../../../../assets/images/pages/home/selected-services-section/ArrowRight.svg";
import { Link } from "react-router-dom";
import styles from "./OffersWeek.module.scss";
import HomeServices from "../../../../pages/home/homeService/HomeService";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
const OffersWeek = ({
  isControlBtnsVisible = false,
}: {
  isControlBtnsVisible?: boolean;
}) => {
  const [offerWeek, setOfferWeek] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const theme = useSelector((state: RootState) => state.theme.mode);
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage?.code
  );
  const swiperRef = useRef<any>(null);
  const goToNextSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slideNext();
    }
  };
  const backToPrevSlide = () => {
    if (swiperRef.current) {
      swiperRef.current.swiper.slidePrev();
    }
  };
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );

  useEffect(() => {
    const fetchOfferWeek = async () => {
      try {
        const response = await HomeServices.getOfferWeek();

        if (response) {
          setOfferWeek(response.data);
        } else {
          setOfferWeek([]);
        }
      } catch (error) {
        console.error("Məhsul gəlmədi", error);
        setOfferWeek([]);
      } finally {
        setLoading(false);
      }
    };
    fetchOfferWeek();
  }, [selectedLanguage]);
  const showSkeletons = loading || offerWeek.length === 0;

  if (!loading && offerWeek.length === 0) {
    return null;
  }

  return (
    <section id={styles.offers_week_section}>
      <div className="container">
        <div className={styles.offers_week_section}>
          <div className={styles.offers_week_slider}>
            <div>
              <div className={styles.section_head}>
                <h1 className={styles.title}>{translations.offers_week}</h1>
                {!isControlBtnsVisible && (
                  <div className={styles.next_prev_buttons}>
                    <div
                      onClick={backToPrevSlide}
                      className={styles.prev_btn}
                    >
                      <img src={arrow_right} alt="arrow-right" width="40" height="40" />
                    </div>
                    <div onClick={goToNextSlide} className={styles.next_btn}>
                      <img src={arrow_right} alt="" width="40" height="40" />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.slider}>
              <Swiper
                ref={swiperRef}
                loop={!showSkeletons && offerWeek.length > 1}
                slidesPerView={3}
                spaceBetween={24}
                className={styles.heroSwiper}
                breakpoints={{
                  0: { slidesPerView: 1.2 },
                  480: { slidesPerView: 1.2 },
                  576: { slidesPerView: 1.2 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 2.3 },
                  1280: { slidesPerView: 3.3 },
                }}
              >
                {showSkeletons
                  ? [1, 2, 3, 4].map((idx) => (
                    <SwiperSlide className={styles.heroSwiperSlide} key={`skeleton-${idx}`}>
                      <div className={styles.offers_card}>
                        <div className={styles.skeletonImage}></div>
                        <div className={styles.skeletonText}></div>
                      </div>
                    </SwiperSlide>
                  ))
                  : offerWeek.map((offer: any, idx: number) => (
                    <SwiperSlide
                      className={`${styles.heroSwiperSlide}`}
                      key={`${offer.id}-${idx}`}
                    >
                      <Link to={`/productDetail/${offer.slug}`}>
                        <div className={styles.offers_card}>
                          <div className={styles.cardDate}>
                            {offer.date}
                          </div>
                          <div className={theme === "light" ? styles.img : styles.img_dark}>
                            <img
                              src={offer.cover_image}
                              alt={offer.name}
                              width="100%"
                              height="242"
                              loading={idx === 0 ? "eager" : "lazy"}
                              // @ts-ignore
                              fetchpriority={idx === 0 ? "high" : "auto"}
                            />
                          </div>
                          {offer.discount_percentage > 0 && (
                            <div className={styles.cardDiscount}>
                              <p className={styles.discount}>
                                {offer.discount_percentage}%
                              </p>
                            </div>
                          )}
                          <div className={styles.cardBottom}>
                            {offer.discount_price > 0 ? (
                              <>
                                <p className={styles.cardBottomTitle}>
                                  {offer.price} AZN
                                </p>
                                <p className={styles.cardBottomText}>
                                  {offer.discount_price} azn
                                </p>
                              </>
                            ) : (
                              <p className={styles.cardBottomText}>
                                {offer.price} AZN
                              </p>
                            )}
                          </div>
                          <h3 className={theme === "dark" ? styles.cardName_dark : styles.cardName}>
                            {offer.name}
                          </h3>
                        </div>
                      </Link>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OffersWeek;
